import { gql } from '@apollo/client';

//Queries
// !!!!! dateOfBirth !!!!!
export const GET_USER_INFO_BY_USER_ID = gql`
  query getUserInfoByUserId($userId: String!) {
    userById(id: $userId) {
      userId: id
      fullName
      email
      phoneNumber
      address
      addressLine2
      city
      province
      postalCode
      country
      dateOfBirth
    }
  }
`;

export const GET_AVAILABLE_ROOM_TYPES_BY_DATE_RANGE = gql`
  query getAvailableRoomTypesByDateRange($input: RoomTypeByDateRangeInput!) {
    availableRoomTypesByDateRange(data: $input) {
      roomTypeId: id
      name
      description
      capacity
      bed
      hasWindows
      pricePerNight
      availableRooms
      # features
      
    }
  }
`;

export const ROOM_SELECTION = gql`
  query roomSelection($data: RoomSelectionInput!) {
    roomSelection(data: $data) {
      roomSelection {
        id
        roomNumber
        roomType {
          id
          name
        }
      }
    }
  }
`;

export const UPGRADE_BOOKING_ROOM_TYPE = gql`
  mutation upgradeBookingRoomType($data: UpgradeBookingRoomTypeInput!) {
    upgradeBookingRoomType(data: $data) {
      id
      status
      isGroupBooking
      isPrimaryBooking
      checkInDate
      checkOutDate
      updatedAt
    }
  }
`;


export const GET_AVAILABLE_ROOMS_BY_ROOM_TYPE_ID_AND_DATE_RANGE = gql`
  query getAvailableRoomsByRoomTypeIdAndDateRange($input: RoomAvailabilityInput!) {
    roomsAvailability(data: $input) {
      roomId: id
      roomNumber
      roomType {
        name
        pricePerNight
      }
    }
  }
`;


export const GET_BOOKINGS_BY_GROUP_ID = gql`
  query bookingsByGroupId($groupId: String!) {
    bookingsByGroupId(groupId: $groupId) {
        bookingId: id
        email
        phoneNumber
        fullName
        reservationCode
        checkInDate
        checkOutDate
        cancellationReason
        cancelledAt
        checkedOutAt
        otpExpiresAt
        checkedInAt
        cancellationFee
        isPickupRequested
        isRoomTypeUpgradeable
        status
        isDeleted
        isGroupBooking
        isPrimaryBooking
        numberOfRoomKeys
        checkOutOTP
        createdAt
        updatedAt
          group {
            id
            ratePlan {
                id
                ratePlan {
                    id
                    title
                    rateChangeType
                    rateChangeValue
                }
            }
        }
        addons {
            id
            pricePerNight
            quantity
            isDeleted
            createdAt
            updatedAt
            bookingAddOn {
                id
                title
                label
                description
                pricePerNight
                isOneTimePriced
                isDeleted
                createdAt
                updatedAt
            }
        }
    }
  }
`;

export const GET_TENANT_INFO_BY_USER_ID = gql`
  query getTenantInfoByUserId($userId: String!) {
    tenantByUserID(userId: $userId) {
      tenantId: id
      groups {
        group {
          groupId: id
          # status
          primaryBookingCode
          primaryBookingStatus
          isSingleton
          isDeleted
          numberOfRooms
          numberOfGuests
           coupon {
                    id
                    title
                    discount
                    rateType
                }
        ratePlan {
        	ratePlan {
            title
            rateChangeValue
          }
        }
          tenants {
            tenant {
              user {
                userId: id
                fullName
                phoneNumber
              }
            }
          }
          addOns {
            groupSubscribedAddOnId: id
            bookingAddOn {
              addOnId: id
              label
            }
          }
          bookings {
            bookingId: id
            reservationCode
            checkOutDate
            checkInDate
            fullName
            phoneNumber
            checkInDate
            checkOutDate
            status
            isDeleted
            numberOfRoomKeys
            isWheelchairAccessible
            cancellationFee
              addons {
                 id
                 pricePerNight
                 quantity
                 isDeleted
                 createdAt
                 updatedAt
                 numberOfNights
                bookingAddOn {
                       id
                       title
                       label
                       description
                       pricePerNight
                       isOneTimePriced
                       isDeleted
                }
            }
            tenantGroup {
              isPrimaryTenant
              tenant {
                user {
                  userId: id
                  fullName
                  phoneNumber
                }
              }
            }
            roomBookings {
              pricePerNight
              numberOfNights
              totalPrice
              status
              isCurrent
              isDeleted
              room {
                roomId: id
                roomNumber
                roomType {
                  roomTypeId: id
                  name
                  bed
                  hasWindows
                  capacity
                }
              }
            }
          }
          bills {
            billId: id
            subTotal
            MAT
            HST
            total
            updatedAt
              transactions {
                id
                type
                isRefunded
            }
            charges {
            id
            bookingId
            description
            quantity
            unitPrice
            amount
            isDeleted
            type
            description
            }
          }
          reviews {
            reviewId: id
            rating
            comment
          }
        }
      }
      paymentCards {
        paymentCardId: id
        holderName
        groupId
        postalCode
        city
        province
        streetAddress
        streetAddressLine2
        country
        transaction {
          creditCardNumber: field1008
          cardExpirationDate: field0004
        }
        isPrimary
      }
    }
  }
`;

export const GET_ALL_BOOKING_ADD_ONS = gql`
  query getAllBookingAddOns {
    validBookingAddons {
      addOnId: id
      title
      label
      description
      pricePerNight
      isOneTimePriced
    }
  }
`;

export const DASHBOARD_CHANGE_BOOKING_ADDONS = gql`
  mutation SubscribeBookingAddons($input: SubscribeToAddonInput!) {
    subscribeBookingAddons(data: $input) {
      id
    }
  }
`;

export const APPLY_COUPON = gql`
  query applyCoupon($couponCode: String!) {
    couponByCode(couponCode: $couponCode) {
      couponId: id
      discount
      couponCode
      rateType
      isActive
      validFrom
      validTo
    }
  }
`;

// Mutation
export const SIGN_IN = gql`
  mutation signIn($input: LoginInput!) {
    authenticate(data: $input) {
      accessToken
    }
  }
`;

// export const SIGN_UP = gql`
//   mutation signUp($input: SignUpInput!) {
//     signupTenant(data: $input) {
//       id
//     }
//   }
// `;


// export const SIGN_UP = gql`
//   mutation signupTenantBasic($data: CreateTenantFromSignupInput!) {
//     signupTenantBasic(data: $data) {
//       id
//       user {
//         id
//         fullName
//         email
//         status
//         userCreationGateway
//         isDeleted
//         createdAt
//         updatedAt
//       }
//       isDeleted
//       createdAt
//       updatedAt
//     }
//   }
// `;


export const SIGN_UP = gql`
  mutation signupTenantBasic($data: CreateTenantFromSignupInput!) {
    signupTenantBasic(data: $data) {
      tenantId
      email
      emailResetToken
    }
  }
`;



export const SETUP_USER_PASSWORD = gql`
  mutation setupUser($input: UserSetupInput!) {
    setupUserPassword(data: $input) {
      id
    }
  }
`;


export const SETUP_USER_PASSWORD_NEW = gql`
  mutation setupUser($input: UserSetupInput!) {
    setupUserPassword(data: $input) {
      auth {
        accessToken
        type
      }
      user {
        id
        email
      }
    }
  }
`;


export const SEND_PHONE_NUMBER_VERIFICATION_CODE = gql`
  mutation sendPhoneNumberVerificationCode($input: SendPhoneNumberVerificationSMSInput!) {
    sendPhoneNumberVerificationSMS(data: $input) 
  }
`;

export const VERIFY_PHONE_NUMBER = gql`
  mutation verifyPhoneNumber($input: VerifyPhoneNumberInput!) {
    verifyPhoneNumber(data: $input) 
  }
`;

export const CREATE_GROUP_BOOKING = gql`
  mutation createGroupBooking($input: GroupTenantBookingInput!) {
    createGroupBooking(data: $input) {
      resetToken
      bookings {
        reservationCode
        tenantGroup {
          tenant {
            user {
              userId: id
              email
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_BOOKING_BY_BOOKING_ID = gql`
  mutation updateBookingByBookingId($bookingId: String!, $input: UpdateBookingInput!) {
    updateBooking(id: $bookingId, data: $input) {
      id
    }
  }
`;

export const UPDATE_ROOM_TYPE_BY_BOOKING_ID = gql`
  mutation updateRoomTypeByBookingId($bookingId: String!, $input: UpdateBookingRoomTypeInput!) {
    updateBookingRoomType(bookingId: $bookingId, data: $input) {
      id
    }
  }
`;

export const UPDATE_GROUP_BY_GROUP_ID = gql`
  mutation updateGroupByGroupId($groupId: String!, $input: UpdateGroupInput!) {
    updateGroup(id: $groupId, data: $input) {
      id
    }
  }
`;

export const RESET_EMAIL_BY_TOKEN = gql`
  mutation resetEmailByToken($input: ResetEmailInput!) {
      resetEmail(data: $input)
  }
`;

export const UPDATE_USER_INFO_BY_USER_ID = gql`
  mutation updateUserInfoByUserId($userId: String! ,$input: UpdateUserInput!) {
    updateUser(id: $userId, data: $input) {
      userId: id
    }
  }
`;


// Account > Personal Details
export const DASHBOARD_UPDATE_PERSONAL_DETAILS_BY_USER_ID = gql`
  mutation dashboardUpdatePersonalDetailsByUserId(
    $userId: String!
    $input: UpdateUserInput!
  ) {
    updateUser(id: $userId, data: $input) {
      userId: id
      fullName
      address
      addressLine2
      city
      province
      postalCode
      country
      dateOfBirth
    }
  }
`;

export const DASHBOARD_SEND_EMAIL_VERIFICATION = gql`
  mutation sendEmailVerification($input: SendEmailVerificationInput!) {
    sendEmailVerification(data: $input) 
  }
`;

export const DASHBOARD_CHANGE_EMAIL = gql`
  mutation changeEmail($input: VerifyAccountInput!) {
    changeEmail(data: $input) {
      userId: id
      email: email
    }
  }
`;

export const DASHBOARD_SEND_PHONE_VERIFICATION = gql`
  mutation sendPhoneNumberVerification($input: SendPhoneNumberVerificationInput!) {
    sendPhoneNumberVerification(data: $input)
  }
`;

export const DASHBOARD_CHANGE_PHONE = gql`
  mutation changePhoneNumber($input: VerifyPhoneNumberInput!) {
    changePhoneNumber(data: $input) {
      userId: id
      phoneNumber: phoneNumber
    }
  }
`;

export const DASHBOARD_CREATE_EMAIL_SUBSCRIPTION = gql`
  mutation createEmailSubscription($input: CreateSubscriptionInput!) {
    createEmailSubscription(data: $input) {
        id
        isCancelled
        cancellationReason
        userId
        createdAt
        updatedAt
    }
  }
`;

export const DASHBOARD_EMAIL_SUBSCRIPTIONS_BY_USER = gql`
  query emailSubscriptionsByUser($userId: String!) {
    emailSubscriptionsByUser(userId: $userId) {
      id
      isCancelled
      cancellationReason
      userId
      createdAt
      updatedAt
        subscriptionType {
          id
          type
      }
    }
  }
`;

// Old query:
// export const DASHBOARD_EMAIL_SUBSCRIPTIONS_BY_USER = gql`
//   query emailSubscriptionsByUser($userId: String!) {
//     emailSubscriptionsByUser(userId: $userId) {
//       id
//       isCancelled
//       cancellationReason
//       userId
//       createdAt
//       updatedAt
//         subscriptionTypes {
//                 subscriptionType {
//                 id
//                 type
//             }
//         }
//     }
//   }
// `;




export const DASHBOARD_CREATE_PHONE_SUBSCRIPTION = gql`
  mutation createPhoneSubscription($input: CreateSubscriptionInput!) {
    createPhoneSubscription(data: $input) {
        id
        isCancelled
        cancellationReason
        userId
        createdAt
        updatedAt
    }
  }
`;

export const DASHBOARD_PHONE_SUBSCRIPTIONS_BY_USER = gql`
  query phoneSubscriptionsByUser($userId: String!) {
    phoneSubscriptionsByUser(userId: $userId) {
      id
      isCancelled
      cancellationReason
      userId
      createdAt
      updatedAt
                subscriptionType {
                id
                type
            }
    }
  }
`;

// Old query
// export const DASHBOARD_PHONE_SUBSCRIPTIONS_BY_USER = gql`
//   query phoneSubscriptionsByUser($userId: String!) {
//     phoneSubscriptionsByUser(userId: $userId) {
//       id
//       isCancelled
//       cancellationReason
//       userId
//       createdAt
//       updatedAt
//         subscriptionTypes {
//                 subscriptionType {
//                 id
//                 type
//             }
//         }
//     }
//   }
// `;

export const DASHBOARD_PHONE_UNSUBSCRIPTION = gql`
mutation unsubscribePhone($id: String!) {  
    unsubscribePhone(id: $id)
}
`;

export const DASHBOARD_PHONE_RESUBSCRIPTION = gql`
mutation resubscribePhone ($id: String!) {
    resubscribePhone(id: $id)
}
`;


export const RESET_PASSWORD = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(data: $input) {
      userId: id
      email: email
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(data: $input)
  }
`;

// Old mutation?
export const CREATE_PAYMENT_CARD = gql`
  mutation createPaymentCard($input: CreatePaymentCard!) {
    createTenantPaymentCard(data: $input) {
      id
    }
  }
`;

export const CREATE_GROUP_PAYMENT_CARD = gql`
  mutation createGroupPaymentCard($input: CreatePaymentCard!) {
    createPaymentCard(data: $input) {
      id
      tenantId
      groupId
      holderName
      streetAddress
      streetAddressLine2
      city
      province
      postalCode
      country
      isPrimary
      isDeleted
      createdAt
      updatedAt
      isOTAPrepayment
    }
  }
`;

export const DELETE_CREDIT_CARD = gql`
  mutation deleteCreditCard($paymentCardId: String!) {
    removePaymentCard(id: $paymentCardId) {
      id
    }
  }
`;

export const SET_CREDIT_CARD_PRIMARY = gql`
  mutation setCreditCardPrimary($input: SetPrimaryPaymentCard!) {
    setPrimaryPaymentCard(data: $input) {
      id
    }
  }
`;

export const CREATE_REVIEW_BY_GROUP_ID = gql`
  mutation createReviewByGroupId($input: CreateBookingReviewInput!) {
    createBookingReview(data: $input) {
      id
    }
  }
`;

export const UPDATE_REVIEW_BY_GROUP_ID = gql`
  mutation updateReviewByGroupId($groupId: String!, $input: UpdateBookingReviewInput!) {
    updateBookingReview(groupId: $groupId, data: $input) {
      id
    }
  }
`;

// Old DELETE booking mutation
export const DELETE_GROUP_BY_GROUP_ID = gql`
  mutation deleteGroupByGroupId($groupId: String!, $input: DeleteBookingInput! ) {
    deleteGroup(id: $groupId, data: $input) {
        id
        isDeleted
    }
  }
`;

// Old DELETE booking mutation
export const DELETE_BOOKING_BY_BOOKING_ID = gql`
  mutation deleteBookingByBookingId($bookingId: String!,  $input: DeleteBookingInput! ) {
    deleteBooking(id: $bookingId, data: $input) {
      id,
      status,
      isDeleted
    }
  }
`;


export const WEBSITE_CANCEL_BOOKING = gql`
  mutation websiteCancelBooking($data: WebsiteCancelBookingInput!) {
    websiteCancelBooking(data: $data) {
      success
      cancellationFeeApplied
    }
  }
`;


export const UPDATE_PASSWORD_BY_USER_ID = gql`
  mutation updatePasswordByUserId($userId: String!, $input: ChangePasswordInput!) {
    changePassword(id: $userId, data: $input) {
      id
    }
  }
`;

export const UPDATE_GUEST_INFORMATION = gql`
  mutation updateGuestInformation($input: GuestInformationInput!) {
    updateGuestInformation(data: $input) {
      giestID: id
      phoneNumber
      fullName
      numberOfRoomKeys 
    }
  }
`;

export const SUBSCRIBE = gql`
  mutation subscribe($input: CreateEmailSubscriptionInput!) {
    createEmailSubscription(data: $input) {
      id
    }
  }
`;

export const SUBSCRIBE_TO_MAILING_LIST = gql`
  mutation subscribeToMailingList($input: CreateEmailSubscriptionInput!) {
    subscribeToMailingList(data: $input) {
      id
      isCancelled
      subscriptionType {
        type
      }
    }
  }
`;




// New mutaton for UNSUBSCRIBE from e-mail link
export const UNSUBSCRIBE_EMAIL = gql`
  mutation UnsubscribeEmail($id: String!, $reason: String) {
    unsubscribeEmail(id: $id, reason: $reason)
  }
`;

// New mutaton for RESUBSCRIBE_EMAIL from e-mail link
export const RESUBSCRIBE_EMAIL = gql`
  mutation ResubscribeEmail($id: String!) {
    resubscribeEmail(id: $id)
  }
`;


export const CREATE_UNSUBSCRIPTION_REASON = gql`
  mutation createUnsubscriptionReason($unsubscribeId: String!,$input: AddEmailReSubscriptionCancellationInput!) {
    emailUnsubscriptionReason(id: $unsubscribeId, data: $input)
  }
`;

export const SOCIAL_LOGIN = gql`
  mutation SocialLogin($input: SocialLoginInput!) {
    socialLogin(input: $input) {
      accessToken
      type
    }
  }
`;

export const CHANGE_BOOKING_ROOM_TYPE = gql`
  mutation changeBookingRoomType($input: ChangeBookingRoomTypeInput!) {
    changeBookingRoomType(data: $input) {
      id
      reservationCode
      roomType { id name }
      status
    }
  }
`;

export const SUBMIT_DATA_DELETION_REQUEST = gql`
  mutation submitDataDeletionRequest($data: SubmitDataDeletionRequestInput!) {
    submitDataDeletionRequest(data: $data) {
      id
      status
      createdAt
    }
  }
`;

export const CAN_CHANGE_GROUP_ROOM_TYPE = gql`
  query CanChangeGroupRoomType($data: CanChangeGroupRoomTypeInput!) {
    canChangeGroupRoomType(data: $data)
  }
`;


export const CANCELLATION_PREVIEW = gql`
  query CancellationPreview($data: CancellationPreviewInput!) {
    cancellationPreview(data: $data) {
      isFree
      cancellationFeeAmount
      message
      freeCancellationDeadline
      depositAmount
    }
  }
`;



export const CONFIRM_DATA_DELETION_REQUEST = gql`
  mutation confirmDataDeletionRequest($data: ConfirmDataDeletionRequestInput!) {
    confirmDataDeletionRequest(data: $data) {
      ok
    }
  }
`;
